export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.linate_admin_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
